import React from "react";
import "../styles/questionpreviewsheet.css";

const QuestionPreviewSheet = ({
    question,
    questionNumber,
    totalQuestions,
    userAnswer,
    onClose,
    onPrevious,
    onNext
}) => {

    if (!question) return null;

    const renderOption = (option) => {

        if (!option) return null;

        const isSelected = userAnswer === option;
        const isCorrect = question.Answer === option;

        let cls = "qps-option";

        if (isCorrect) {
            cls += " correct";
        } else if (isSelected) {
            cls += " wrong";
        }

        return (

            <div className={cls} key={option}>

                <div className="qps-radio">

                    {
                        isCorrect
                            ? "✓"
                            : isSelected
                                ? "✕"
                                : ""
                    }

                </div>

                <div className="qps-option-text">

                    {option}

                </div>

            </div>

        );

    };

    return (

        <>

            <div
                className="qps-backdrop"
                onClick={onClose}
            />

            <div className="qps-sheet">

                <div className="qps-handle" />

                <div className="qps-header">

                    <div>

                        <div className="qps-number">

                            Question {questionNumber} / {totalQuestions}

                        </div>

                    </div>

                    <button
                        className="qps-close"
                        onClick={onClose}
                    >
                        ✕
                    </button>

                </div>

                <div className="qps-question">

                    {question.Question}

                </div>

                {

                    question.Image1 &&

                    <img
                        className="qps-image"
                        src={`https://epolylearning.com/QuestionImages/${question.QuestionId}-1.png`}
                        alt=""
                    />

                }

                {

                    question.Image2 &&

                    <img
                        className="qps-image"
                        src={`https://epolylearning.com/QuestionImages/${question.QuestionId}-2.png`}
                        alt=""
                    />

                }

                <div className="qps-options">

                    {renderOption(question.Option1)}
                    {renderOption(question.Option2)}
                    {renderOption(question.Option3)}
                    {renderOption(question.Option4)}
                    {renderOption(question.Option5)}

                </div>

                <div className="qps-info">

                    <div className="qps-info-row">

                        <strong>Your Answer</strong>

                        <span>

                            {userAnswer || "Not Attempted"}

                        </span>

                    </div>

                    <div className="qps-info-row">

                        <strong>Correct Answer</strong>

                        <span>

                            {question.Answer}

                        </span>

                    </div>

                </div>

                {

                    question.Explanation &&

                    <div className="qps-explanation">

                        <h4>Explanation</h4>

                        <p>{question.Explanation}</p>

                    </div>

                }

                <div className="qps-footer">

                    <button
                        className="qps-nav-btn"
                        onClick={onPrevious}
                        disabled={questionNumber === 1}
                    >
                        ◀ Previous
                    </button>

                    <button
                        className="qps-nav-btn"
                        onClick={onNext}
                        disabled={questionNumber === totalQuestions}
                    >
                        Next ▶
                    </button>

                </div>

            </div>

        </>

    );

};

export default QuestionPreviewSheet;